// extracted by mini-css-extract-plugin
export default {"base":"footer_base__jCBEt"};